import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeftSideNavigationExampleComponent } from './left-side-navigation-example/left-side-navigation-example.component';

const routes: Routes = [
  {
    path: 'sidenav-example',
    component: LeftSideNavigationExampleComponent,
    data: { title: 'Left Side Navigation' },
  },
  {
    path: '',
    loadChildren: () => import('./shell/shell.module').then(m => m.ShellModule),
  },
  {
    path: '**',
    redirectTo: '/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled'
      }
    )
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
